import { AdjustRounded } from "@mui/icons-material";
import { Box, Card, CardContent, Icon, Stack, Typography } from "@mui/material"
import Image from "next/image";
import EkhoolImage from "../components/ekhoolImage/ekhoolImage";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

const CustomContent2 = ({ item, ...props }) => {

    const { reducer, pageJson } = useSelector((state) => state);
    const { isSiteBuilder, siteBuilderSelectedChild } = reducer;
    const fontFamily = reducer?.pageJson?.pageStyle?.fontFamily || 'Roboto';

    const { content } = item;
    
    const {push} = useRouter();

    if(!content)
    {
        return <></>
    }

    const { title, icon } = content;

    return (
        <Card
            onClick={() => {
                if (!isSiteBuilder) {
                if (typeof item?.url === "object") {
                    // push(item?.props?.url?.path);
                    if (item?.url?.target){
                        window.open(item?.url?.path, "_blank", "noopener,noreferrer");
                    }else{
                        push(item?.url?.path)
                    }
                } else {
                    push(item?.url)
                }
                }
            }}
            sx={{
                ...(!isSiteBuilder &&
                  item?.url && {
                    cursor: "pointer",
                    "&:hover": {},
                  }),
                  height: '100%'
              }}

        >
            <CardContent>

                <Stack {...props} >
                    {
                        content?.src &&
                        <Box   
                            position={'relative'}
                            overflow={'hidden'}
                            display={'flex'}
                            justifyContent={'center'} 
                            minWidth={300}
                            height={300}
                        >
                            <EkhoolImage layout={'fill'} objectFit={'contain'} src={content?.src}/>

                        </Box>
                    }

                    {
                        icon &&
                        <Box>
                            <Icon fontSize={'medium'} className={`mdi mdi-${icon}`} sx={{ height: '100%' }} />
                        </Box>
                    }

                    <Typography variant="h6" color={'text.primary'} data-sb-field="title" sx={{fontFamily:`${fontFamily}!important`}} >{title}</Typography>
                    <Typography color={'text.primary'} variant={'body2'} data-sb-field="content" sx={{fontFamily:`${fontFamily}!important`}}>{content?.content}</Typography>

                    
                </Stack>

            </CardContent>

        </Card>
    )
};

export default CustomContent2;